define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("user-management-templates/skills/customSettingsTransferToAgentOptionView.tmpl");
    var Dropdown = require("ui/dropdown/Dropdown");
    var InputField = require("ui/input-field/InputField");
    var TimeUtilities = require("utils/TimeUtilities");

    var CustomSettingsTransferToAgentOptionView = {};

    LE.module("LEUserManagement", function (LEUserManagement, LE, Backbone, Marionette, $, _) {
        CustomSettingsTransferToAgentOptionView = Marionette.ItemView.extend({
            template : template,
            className: "transfer-to-agent-custom-settings-container",
            ui: {
                transferToAgentEditContainer: ".transfer-to-agent-edit-container",
                transferToAgentInput: ".transfer-to-agent-input-container",
                transferToAgentDropdown: ".transfer-to-agent-dropdown-container"
            },
            uiComponents: {
                transferToAgentUnitsDropDown: {
                    type: Dropdown,
                    options: {
                        container: "view.ui.transferToAgentDropdown",
                        items: "view._getUnitsOptions",
                        permutation: Dropdown.PERMUTATION.XX_SMALL1,
                        selectedOption: "view._getSelectedUnits"
                    },
                    events: {
                        change: "_onUnitChange"
                    }
                },
                transferToAgentInput: {
                    type: InputField,
                    options: {
                        el: "view.ui.transferToAgentInput",
                        permutation: InputField.Permutation.K,
                        maxLength: 4,
                        inputType: InputField.prototype.InputTypeEnum.NaturalNumber,
                        value: "view._getInput"
                    },
                    events: {
                        change: "_onInputChange"
                    }
                },
            },

            initialize: function(options) {
                this.channel = options.channel;
            },

            onRender: function() {
                this.toggleCustomConfigurationVisibility();
            },

            setError: function (isError, errorMsg) {
                this._setError(isError, errorMsg);
            },

            toggleCustomConfigurationVisibility: function() {
                var show = !!this.model.getTransferToAgentType();
                this.ui.transferToAgentEditContainer.toggleClass("hide", !show);
            },

            updateTransferToAgentTime: function(defaultResponseTimeInSeconds) {
                var transferToAgentValue = TimeUtilities.convertSecondsToOtherUnit(defaultResponseTimeInSeconds);

                this.uiComponents.transferToAgentInput.setValue(transferToAgentValue.time);
                this.uiComponents.transferToAgentUnitsDropDown.setSelection(transferToAgentValue.unit);
            },

            _getUnitsOptions: function() {
                var unitsList = TimeUtilities.gerTranslatedUnits();
                return new Dropdown.Collection(unitsList);
            },

            _getSelectedUnits: function() {
                var transferToAgentInSeconds = this.model.getTransferToAgent();
                return TimeUtilities.convertSecondsToOtherUnit(transferToAgentInSeconds).unit;
            },

            _getInput: function() {
                var transferToAgentInSeconds = this.model.getTransferToAgent();
                var transferToAgentValue = TimeUtilities.convertSecondsToOtherUnit(transferToAgentInSeconds);
                return (transferToAgentValue && transferToAgentValue.time) ? transferToAgentValue.time : "";
            },

            _onInputChange: function(componentId, eventName, value) {
                var transferToAgentValue = {
                    timeValue: value,
                    timeUnit: this.uiComponents.transferToAgentUnitsDropDown.getValue()
                };
                this.channel.trigger("skill:change:transferToAgent", transferToAgentValue);
            },

            _onUnitChange: function(componentId, eventName, transferUnit) {
                var transferToAgentValue = {
                    timeValue: this.uiComponents.transferToAgentInput.getValue(),
                    timeUnit: transferUnit.selectedKey
                };
                this.channel.trigger("skill:change:transferToAgent", transferToAgentValue);
            },

            _setError: function (isError, errorMsg) {
                this.uiComponents.transferToAgentInput.setError(isError, errorMsg);
            },

            onClose: function() {
                LEUserManagement.logger.debug("onClose", "CustomSettingsTransferToAgentOptionView:onClose");
            }
        });
    });

    return CustomSettingsTransferToAgentOptionView;
});
